import { StyledButton } from "./styles";
import buttonTokens from "./buttonTokens";

export default function Button({
  children,
  variant = "contained",
  disabled = false,
  color = "primary",
  startIcon,
  endIcon,
  size = "M",
  ...props
}) {
  // Достаём нужные размеры из токенов (или M, если не нашли)
  const { width, height, fontSize, paddingX, gap } = buttonTokens.sizes[size] || buttonTokens.sizes.M;
  const borderRadius = buttonTokens.borderRadius;

  return (
    <StyledButton
      variant={variant}
      disabled={disabled}
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      // Пробрасываем параметры как временные пропсы со знаком $, 
      // чтобы потом считать их в styles.js
      $width={width}
      $height={height}
      $fontSize={fontSize}
      $paddingX={paddingX}
      $gap={gap}
      $borderRadius={borderRadius}
      {...props}
    >
      {children}
    </StyledButton>
  );
}
